(ns dre.pages.videos.views
  (:require
   [dre.components.breadcrumb :refer [breadcrumb]]
   [dre.components.video-player :refer [player]]
   [dre.i18n.utils :refer [tr-later]]
   [dre.i18n.views :refer [tr]]
   [dre.page-util :refer [enum]]
   [dre.utils.bem :as bem]))

(def component-name :videos)

(def videos
  [{:id "698673185"
    :key "60e9b0c79e"
    :label (tr-later "Running a search")}
   {:id "698671059"
    :key "262c50315d"
    :label (tr-later "Using Search operators & filters")}
   {:id "698672727"
    :key "5f4397bb8a"
    :label (tr-later "Reviewing a search")}
   {:id "698672273"
    :key "bfc634c430"
    :label (tr-later "Refining a search")}
   {:id "698671917"
    :key "6f6039fcc1"
    :label (tr-later "Identify Key Opinion Leaders")}
   {:id "698674121"
    :key "41e7ddf7e6"
    :label (tr-later "Saving & sharing a search")}
   {:id "698671563"
    :key "ff0e01b2a9"
    :label (tr-later "What are the Data Sources?")}
   {:id "698673810"
    :key "4dfa08943d"
    :label (tr-later "Identify Real World Evidence")}])

(defn vid
  [{:keys [id key label]}]
  [:div
   {:class (bem/be component-name :item)}
   [:h3 label]
   [player id key :player-conf {:width "100%" :height "365px"}]])

(defn view
  []
  [:div
   {:class component-name}
   [:div
    {:class (bem/be component-name :nav)}
    [breadcrumb]]
   [:div
    {:class (bem/be component-name :title)}
    [tr "These help videos are designed to assist you with functionality in LitSearch. The videos reference the look of our previous UI, but LitSearch's functionality remains the same."]]
   [:div
    {:class (bem/be component-name :items)}
    (doall
     (for [[i v] (enum videos)]
       ^{:key i}
       [vid v]))]])
